












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { doublePrevention } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
@Component({
  components: {},
  mixins: [TableStripe],
})
export default class StatisticsPage extends Vue {
  private tableData: any = [];
  private orgUnitGroup: any = {};
  private statisticsData: any = {};
  private tableLoading: any = false;
  mounted() {
    this.tableData = [];
    this.tableLoading = true;
    doublePrevention.getEmergencyDrillRecordsStatisticsData({}).then((res: any) => {
      this.tableLoading = false;
      if (res.code === '200') {
        this.orgUnitGroup = res.data.orgUnitGroup;
        this.statisticsData = res.data.statistics;
        this.tableData = res.data.planGroup;
        const tablesFooter: any = document.querySelector('.el-table__header-wrapper table .has-gutter');
        const trFooterAll: any = tablesFooter.querySelectorAll('tr');
        const trFooterTd: any = trFooterAll[0].querySelectorAll('th');
        trFooterTd.forEach((td: any, index: any) => {
          if (!index) {
            td.colSpan = 2;
          } else if (index === 1) {
            td.style.display = 'none';
          }
        });
      }
    });
  }
  objectSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0) {
      const _row = this.flitterData(this.tableData).one[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  flitterData(arr: any) {
    const spanOneArr: any = [];
    let concatOne: any = 0;
    arr.forEach((item: any, index: any) => {
      if (index === 0) {
        spanOneArr.push(1);
      } else {
        //name 修改
        if (item.type === arr[index - 1].type) {
          //第一列需合并相同内容的判断条件
          spanOneArr[concatOne] += 1;
          spanOneArr.push(0);
        } else {
          spanOneArr.push(1);
          concatOne = index;
        }
      }
    });
    return {
      one: spanOneArr,
    };
  }
  private backClose() {
    this.$emit('closePage');
  }
}
